/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import {connect} from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import Icon from '@material-ui/core/Icon';
import {I18n} from 'react-redux-i18n';
import {CAMERA_VIEWS} from '../../app/configuration/cameras';
import { ThreeDRotationSharp } from '@material-ui/icons';
import {cloneDeep, sortBy} from 'lodash';

class ChannelsAvailable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cameraChannels: {}
    };
    this.assignCameras();
  }
  componentDidMount = () => {
    this.assignCameras();
  }
  componentDidUpdate = (prevProps) => {
    if(prevProps.options.machineType !== this.props.options.machineType){
      this.assignCameras();
    }
  }
  assignCameras = () => {
    const camerasList = this.getCameras();
    this.setState({cameraChannels: camerasList});
  }
  getCameras = () => {
    try {
      const {machineType} = this.props.options;
      let camera_views = cloneDeep(CAMERA_VIEWS.get(machineType));
      const camera_views_sorted = sortBy(camera_views, c => c.formOrder);
      return camera_views_sorted;  
    } catch (error) {
      return null;
    }
  };

  handleChange = channelIndex => event => {
    const cameraChannels = this.state.cameraChannels;
    const selectedChannels = [];
    cameraChannels && Object.keys(cameraChannels).forEach((key) => {
      if(cameraChannels[key].channelIndex == channelIndex){
        cameraChannels[key].selected = event.target.checked;
      }
      if(cameraChannels[key].selected){
        selectedChannels.push(cloneDeep(cameraChannels[key]));
      }
    })
    this.props.onChange(selectedChannels);
  }

  render() {
    const {options} = this.props;
    const {cameraChannels} = this.state;
    const isDisabled = channelIndex => {
      if (options.order) {
        return options.order.indexOf(channelIndex) === -1;
      }
      return true;
    };

    const {showLabel = true} = options;
    return (
      <React.Fragment>
        <div className="ondemand__allviewscont">
          {showLabel && (
            <label className="ondemand__col1">{I18n.t('page.onDemand.form.camerasAvailable')}</label>
          )}
          <div className="ondemand__col2">
            {Object.keys(this.state.cameraChannels).map((key) => {
              return (
                <label key={`camera-channel-${cameraChannels[key].key}`} htmlFor={cameraChannels[key].linkName} className={isDisabled(cameraChannels[key].channelIndex) ? 'ondemand__viewcont disableme' : 'ondemand__viewcont'}>
                  <Checkbox id={cameraChannels[key].linkName} checked={cameraChannels[key].selected || false} disabled={isDisabled(cameraChannels[key].channelIndex)} onChange={this.handleChange(cameraChannels[key].channelIndex)}/>
                  <div className={`ondemand__cameraviews ${cameraChannels[key].key}-cam`}>
                    <Icon className="videothumb__camview">{`arrow_${cameraChannels[key].arrowDirection}`}</Icon>{I18n.t(`page.onDemand.form.camera.${cameraChannels[key].key}`)}
                  </div>
                </label>
              )
            })}
            {/* <label htmlFor="frontCamera" className={isDisabled('front') ? 'ondemand__viewcont disableme' : 'ondemand__viewcont'}>
              <Checkbox id="frontCamera" checked={cameras.front} disabled={isDisabled('front')} onChange={this.handleChange('front')} />
              <div className="ondemand__cameraviews ff-cam">
                <Icon className="videothumb__camview">arrow_upward</Icon>{I18n.t('page.onDemand.form.camera.ff')}
              </div>
            </label>
            <label htmlFor="backCamera" className={isDisabled('back') ? 'ondemand__viewcont disableme' : 'ondemand__viewcont'}>
              <Checkbox id="backCamera" checked={cameras.back} disabled={isDisabled('back')} onChange={this.handleChange('back')} />
              <div className="ondemand__cameraviews re-cam">
                <Icon className="videothumb__camview">arrow_downward</Icon>{I18n.t('page.onDemand.form.camera.re')}
              </div>
            </label>
            {camerasList.indexOf('left') > 0 &&
              (
                <label htmlFor="leftCamera" className={isDisabled('left') ? 'ondemand__viewcont disableme' : 'ondemand__viewcont'}>
                  <Checkbox id="leftCamera" checked={cameras.left} disabled={isDisabled('left')} onChange={this.handleChange('left')} />
                  <div className="ondemand__cameraviews dr-cam">
                    <Icon className="videothumb__camview">arrow_back</Icon>{I18n.t('page.onDemand.form.camera.dr')}
                  </div>
                </label>
              )
            }
            {camerasList.indexOf('right') > 0 &&
              (
                <label htmlFor="rightCamera" className={isDisabled('right') ? 'ondemand__viewcont disableme' : 'ondemand__viewcont'}>
                  <Checkbox id="rightCamera" checked={cameras.right} disabled={isDisabled('right')} onChange={this.handleChange('right')} />
                  <div className="ondemand__cameraviews pa-cam">
                    {I18n.t('page.onDemand.form.camera.pa')}<Icon className="videothumb__camview">arrow_forward</Icon>
                  </div>
                </label>
              )
            } */}
          </div>
        </div>
        {showLabel && <div className="ondemand__line">&nbsp;</div>}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(ChannelsAvailable);
